module.exports = __webpack_public_path__ + "img/vertical_3_3_3009.60a00336.png";